import { EntityRepository, Repository } from "typeorm";
import { PostShipmentDetailsEntity } from "../dto/post-shipment-details-entity";


@EntityRepository(PostShipmentDetailsEntity)
export class PostShipmentRepo extends Repository<PostShipmentDetailsEntity> {
    
}